const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const RawImageReviewQueryURL = {
    GetItems: Backofficebff + '/v1/raw-image-review/items',
};
